import { AdminProvider } from 'models';
import moment from 'moment';
import { client } from 'shared';

export const ignoreExperience = (id: number | undefined) => {
    return client(`api/licensed-center-employment/${id}/`, { method: 'PATCH', body: { ignore: true } });
};

export const verifyExperience = (provider: AdminProvider) => {
    return client(`api/babysitter-success-progress/${provider.success_progress[0].id}/`, {
        method: 'PATCH',
        body: { provider_completed_background_check_florida: moment().format('YYYY-MM-DD HH:MM') },
    });
};
